<template>
  <sTooltip
    :border="false"
    :content="reason"
    data-qa="canceled-bid-info"
    :disabled="!reason"
    :open-delay="300"
    placement="bottom"
    popper-class="tender-viewsCount-tooltip info-tooltip"
    type="white">
    <div class="canceled-bid-info">
      <sIcon
        :color="isCanceled ? 'var(--secondary__red)' : 'grey'"
        data-qa="isCanceled"
        type="canceled-file"/>
      <span
        v-if="cancelled !== undefined"
        :class="(cancelled ? 'secondary__red' : 'grey') + '--text'"
        data-qa="canceled-bid-info-cancelled"> {{ cancelled }} </span>
    </div>
  </sTooltip>
</template>
<script>

export default {
  name: 'cancelledBidInfo',
  data() {
    return {
      cancelled_statuses: ['CANCELED', 'CANCELED_BY_ORGANIZER']
    }
  },
  props: {

    cancelled: {
      type: Number,
    },
    bid: {
      type: Object,
    },
  },
  computed: {
    isCanceled() {
      return this.bid?.bidStatus ? this.cancelled_statuses.includes( this.bid?.bidStatus ) : !!this.cancelled
    },
    reason() {
      if ( !this.bid || !this.cancelled_statuses.includes( this.bid.bidStatus )) { return '' }
      return this.$t('Tenders.CancelledBid_' + this.bid?.bidStatus)
    }
  }
}
</script>
